import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'ppl-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PplBadgeComponent {

  @Input() @HostBinding('style.background-color') color: string;

  @Input() @HostBinding('style.font-size.px') fontSize: number = 10;

}
